import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import MainPage from '../pages/MainPage/MainPage.jsx';
import AuthGate from './AuthGate.jsx';
import AdminAuthGate from './AdminAuthGate.jsx';
import { sessionStorage, STORAGE_KEYS } from '../utils/sessionStorage.js';

// A developer tool: never part of the admin page's startup download.
const DevConfigPage = lazy(() => import('../devconfig/DevConfigPage.jsx'));

function ViewerUnavailable() {
  return (
    <div className="flex min-h-screen items-center justify-center text-sm text-gray-500">
      The viewer isn't available in this build.
    </div>
  );
}

function RedirectToSession() {
  const { id } = useParams();
  return <Navigate to={`/admin/sessiondetails/${id}/dashboard`} replace />;
}

function AdminHome() {
  const identity = sessionStorage.get(STORAGE_KEYS.AUTH_IDENTITY);
  if (identity?.sessionId) {
    return <Navigate to={`/admin/sessiondetails/${identity.sessionId}/dashboard`} replace />;
  }
  return <Navigate to="/" replace />;
}

function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<AdminHome />} />
        <Route path="/admin/dashboard" element={<AdminHome />} />
        <Route path="/admin/sessiondetails/:id" element={<RedirectToSession />} />
        <Route path="/admin/sessiondetails/:id/dashboard" element={<AdminAuthGate><MainPage /></AdminAuthGate>} />
        <Route path="/devconfig" element={<Suspense fallback={null}><DevConfigPage /></Suspense>} />
        <Route path="/*" element={<AuthGate><ViewerUnavailable /></AuthGate>} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;
